export const TEXTS_GAUGE_YEAR = {
  es_ES: new Map([
    ['chartAccesosGauge', 'ACCESOS A LA CIUDAD: ACUMULADO AÑO }'],
    ['chartViesGaugeYear', 'VIAS PRINCIPALES DE LA\nCIUDAD: ACUMULADO AÑO  }'],
    ['unidadMedidaVehículos', 'Vehicles'],
    ['tituloGrafica', 'TRÀNSIT DE VEHICLES: ACCESSOS A LA CIUTAT'],
    ['tituloGraficaVias', 'TRÀNSIT DE VEHICLES: VIES PRINCIPALS DE LA CIUTAT'],
  ]),
  ca_ES: new Map([
    ['chartAccesosGauge', 'ACCESSOS A LA CIUTAT: ACUMULAT ANY '],
    ['chartViesGaugeYear', 'VIES PRINCIPALS DE LA\nCIUTAT: ACUMULAT ANY  '],
    ['unidadMedidaVehículos', 'Vehicles'],
    ['tituloGrafica', 'TRÀNSIT DE VEHICLES: ACCESSOS A LA CIUTAT'],
    ['tituloGraficaVias', 'TRÀNSIT DE VEHICLES: VIES PRINCIPALS DE LA CIUTAT'],
  ]),
};
